import type { SmokerStatusEnum, TitleEnum } from "@/enums";
import type { OceanDataModel } from "./dataLayer.model";

export enum DocumentsOptionEnum {
    Online = "online",
    Paper = "paper",
}

export interface CustomerAddressModel {
    line1: string;
    line2: string;
    line3: string;
    line4: string;
    line5: string;
    postcode: string;
}

export interface GdprModel {
    email: boolean;
    phone: boolean;
    post: boolean;
    sms: boolean;
    personalMarketing: boolean;
}

export interface CustomerModel {
    customerID: number;
    customerSecret: string;
    title: TitleEnum;
    firstname: string;
    middlename: string;
    surname: string;
    email: string;
    ncEmail: boolean;
    dobDate: string;
    dobMonth: string;
    dobYear: string;
    smoker: SmokerStatusEnum | undefined;
    selectedAddress: string | null;
    address: CustomerAddressModel;
    dayPhone: string | undefined;
    fbo?: boolean;
    documentsOption: DocumentsOptionEnum;
    gdpr: GdprModel;
    caciData?: OceanDataModel | null;
}
